<template>
  <div>
    <div class="form-group col-md-11 required">
      <label class="control-label">Option 1</label>
      <input
        type="text"
        id="lesson_quiz.option_1"
        name="lesson_quiz.option_1"
        v-bind:class="{ 'has-error': errors.has('lesson_quiz.option_1') }"
        v-validate="'required'"
        v-model="lesson_quiz.option_1"
        class="form-control lesson_quiz.option_1"
        placeholder="Option 1"
      />
      <div class="help text-danger" v-show="errors.has('lesson_quiz.option_1')">
        {{ errors.first("lesson_quiz.option_1") }}
      </div>
    </div>
    <div class="form-group col-md-11 required">
      <label class="control-label">Option 2</label>
      <input
        type="text"
        id="lesson_quiz.option_2"
        name="lesson_quiz.option_2"
        v-bind:class="{ 'has-error': errors.has('lesson_quiz.option_2') }"
        v-validate="'required'"
        v-model="lesson_quiz.option_2"
        class="form-control lesson_quiz.option_2"
        placeholder="Option 2"
      />
      <div class="help text-danger" v-show="errors.has('lesson_quiz.option_2')">
        {{ errors.first("lesson_quiz.option_2") }}
      </div>
    </div>
    <div class="form-group col-md-11">
      <label class="control-label">Option 3</label>
      <input
        type="text"
        id="lesson_quiz.option_3"
        name="lesson_quiz.option_3"
        v-model="lesson_quiz.option_3"
        class="form-control lesson_quiz.option_3"
        placeholder="Option 3"
      />
    </div>
    <div class="form-group col-md-11">
      <label class="control-label">Option 4</label>
      <input
        type="text"
        id="lesson_quiz.option_4"
        name="lesson_quiz.option_4"
        v-model="lesson_quiz.option_4"
        class="form-control lesson_quiz.option_4"
        placeholder="Option 4"
      />
    </div>
    <div class="form-group col-md-11">
      <label class="control-label">Option 5</label>
      <input
        type="text"
        id="lesson_quiz.option_5"
        name="lesson_quiz.option_5"
        v-model="lesson_quiz.option_5"
        class="form-control lesson_quiz.option_5"
        placeholder="Option 5"
      />
    </div>
    <div class="form-group col-md-11">
      <label class="control-label">Correct Option</label>
      <el-select
        v-model="lesson_quiz.correct_option"
        style="width: 100%"
        v-validate="'required'"
        name="lesson_quiz.correct_option"
        placeholder="Select correct options"
      >
        <el-option
          v-for="option in options"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
      <div
        class="help text-danger"
        v-show="errors.has('lesson_quiz.correct_option')"
      >
        {{ errors.first("lesson_quiz.correct_option") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  Name: "Mcq",
  props: ["quiz", "id"],
  data: () => ({
    lesson_quiz: [],
    options: [
      { value: "option_1", label: "Option 1" },
      { value: "option_2", label: "Option 2" },
      { value: "option_3", label: "Option 3" },
      { value: "option_4", label: "Option 4" },
      { value: "option_5", label: "Option 5" },
    ],
  }),
  watch: {
    quiz: function (val, oldVal) {
      this.lesson_quiz = val;
    },
  },
  updated() {
    this.$emit("updateMcq", this.id, this.lesson_quiz);
  },
};
</script>
